import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Provider } from 'react-redux';

import { ApprovalFlowProvider } from '@mint-lib/approval-flow-circuit';
import { RumComponentContextProvider } from '@mint-lib/datadog';
import {
  QueryErrorResetBoundary,
  RTKQueryErrorResetBoundary,
} from '@mint-lib/error-boundary';
import { QueryClientProvider } from '@mint-lib/query-client';
import { useCampaignTitle } from '@mint-lib/routing-context';
import { SlotPortal } from '@mint-lib/slots';
import { getRouteApi, Outlet } from '@mint/routing';

import { queryClient } from '../api/queries/client.js';
import store from '../redux/store.js';

const routeApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

const IndexApp = () => {
  const params = routeApi.useParams();
  const [campaignTitle] = useCampaignTitle(params.campaignId);

  return (
    <RumComponentContextProvider componentArea="planning">
      <QueryClientProvider client={queryClient}>
        <QueryErrorResetBoundary>
          <Provider store={store}>
            <RTKQueryErrorResetBoundary>
              <ApprovalFlowProvider>
                <SlotPortal name="topBarCampaignTitle">
                  {campaignTitle?.title}
                </SlotPortal>
                <SlotPortal name="topBarTitle">
                  {campaignTitle?.title}
                </SlotPortal>
                <Outlet />
              </ApprovalFlowProvider>
            </RTKQueryErrorResetBoundary>
          </Provider>
        </QueryErrorResetBoundary>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </RumComponentContextProvider>
  );
};

export default IndexApp;
